import { CSSProperties, ReactElement, ReactNode, isValidElement } from 'react';
import classNames from 'classnames/bind';
import { rem } from '@utmb/utils/font';
import styles from './my-table.module.scss';

export interface MyTableCellProps {
    children?: ReactNode;
    className?: string;
    column?: number;
    hiddenOnMobile?: boolean;
    hiddenOnDesktop?: boolean;
    paddingHidden?: boolean;
    label?: string | ReactElement;
    height?: number;
}

const cx = classNames.bind(styles);

export const MyTableCell = (props: MyTableCellProps): ReactElement => {
    const { children, className, column, hiddenOnMobile = false, hiddenOnDesktop = false, paddingHidden = false, label, height } = props;

    const style: CSSProperties = {};
    if (height) style.minHeight = rem(height);

    const classesCSS = cx(className, styles.cell, column && `col-${Math.min(column, 12)}`, {
        hide_mobile: hiddenOnMobile,
        hide_desktop: hiddenOnDesktop,
        remove_padding: paddingHidden,
    });

    const isLabelElement = isValidElement(label);

    return (
        <div className={classesCSS} style={style} data-label={!isLabelElement ? (label as string) : undefined}>
            {isLabelElement && <div className={styles.label}>{label}</div>}
            {children}
        </div>
    );
};
